import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/pages/Home';
import ErrorPage from '@/pages/ErrorPage';
import ErrorServer from '@/pages/ErrorServer';

Vue.use(Router);

export default new Router({
  mode: 'history',
  // scrollBehavior: (to) => {
  //   if (to.hash) {
  //     return { selector: to.hash };
  //   }
  //   return { x: 0, y: 0 };
  // },
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/about/',
      name: 'About',
      component: Home,
    },
    {
      path: '/founders/',
      name: 'Founders',
      component: Home,
    },
    {
      path: '/team/',
      name: 'Team',
      component: Home,
    },
    {
      path: '/portfolio/',
      name: 'Portfolio',
      component: Home,
    },
    {
      path: '/news/',
      name: 'News',
      component: Home,
    },
    {
      path: '/privateequity/',
      name: 'PrivateEquity',
      component: Home,
    },
    {
      path: '/contacts/',
      name: 'Contacts',
      component: Home,
    },
    {
      path: '/500/',
      name: 'ErrorServer',
      component: ErrorServer,
    },
    {
      path: '*',
      name: 'ErrorPage',
      component: ErrorPage,
    },

  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js